import script from "./CareerDetailProgramsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CareerDetailProgramsPage.vue?vue&type=script&setup=true&lang=js"

import "./CareerDetailProgramsPage.vue?vue&type=style&index=0&id=996ba9dc&lang=scss"

const __exports__ = script;

export default __exports__